export default __webpack_public_path__ + "static/media/down.5bcde5c1.png";